'use strict';

module.exports = function () {
    $('.info-icon').on('mouseenter focusin', function () {
        $(this).find('.tooltip').removeClass('d-none');
    });

    $('.info-icon').on('mouseleave focusout', function () {
        $(this).find('.tooltip').addClass('d-none');
    });

    $('.info-icon').on('keydown', function (event) {
        if (event.keyCode === 27) {
            $(this).tooltip('hide');
        }
    });

    // Init bootstrap tooltip
    $('[data-toggle="tooltip"]').tooltip();
};
